// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b29d6666] .filters-column span+span:before{content:\"/\"}", ""]);
// Exports
module.exports = exports;
